export default __webpack_public_path__ + "static/media/pie-chart.c4f6463a.svg";